export const VariablesFields = [
  'name',
  'created_at',
  'updated_at',
  'data_model_type',
  'description',
  'number_of_global_uses',
  { created_by: ['id', 'label'] },
]
